import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { CategoriesList, ReferenceParams, Res } from 'src/app/models';
import { ApiOrganizationsService, FilesService, LanguageService, NotificationService } from 'src/app/services';
import { ApiBasicService } from 'src/app/services/api-basic.service';


@Component({
  selector: 'app-file-to-category',
  templateUrl: './file-to-category.component.html',
  styleUrls: ['./file-to-category.component.css']
})
export class FileToCategoryComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  
  categories: CategoriesList[] = [];
  file: any;
  file_ids: string[] = [];
  currentOrg: any;
  categoryId: string;

  form: UntypedFormGroup = this.fb.group({
    category_id: [null],
  });

  

  @Input() set data(value: any) {

    if (value != null) {

      this.file_ids = value.file_ids;
      this.categoryId = value.category_id;
      this.form.get("category_id").setValue(value.category_id);
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private apiOrganizations: ApiOrganizationsService,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiBasicService: ApiBasicService,
    private apiFileService: FilesService
  ) { }

  ngOnInit(): void {

    this.currentOrg = this.apiOrganizations.currentOrganization.id;

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getCategories();
  }

  ngOnDestroy() {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param searchValue - значение для поиска вводимое вручную
   * @param currentElemId - текущее значение из справочника передаваемое при его выборе из списка
   */
  getCategories(): void {

    let params: ReferenceParams = {
      ref_name: 'files_categories',
      filter: {
        name: '',
        parent_id: ''
      }
    }

    this.subscriptions.add(
      this.apiBasicService.getReferences(params, params.ref_name).subscribe((response: Res) => {
        console.log("CATEGORIES: ", response);

        if (response != null) {

          this.categories = response.result;
        }

        this.loading = false;
      },
        error => {
          this.loading = false;
        })
    );
  }

  /**
  * 
  */
  onCreate(): void {

    let obj = {
      org_id: this.currentOrg,
      category_id: this.form.get('category_id').value,
      file_id: this.file_ids
    }

    console.log("OBJ: ", obj);
    
    this.progressRef.start();

    this.subscriptions.add(
      this.apiFileService.addFileToCategory('fileTo', obj).subscribe((response: Res) => {
        console.log('[RESPONSE] ADD FILE TO CATEGORY: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }
}
